















































































































































import Sidebar from '@/calendesk/models/Sidebar'
import Vue from 'vue'
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'
import sidebarTabs from './sidebarTabs/SidebarTabs'
import { ChangeStep } from '@/calendesk/models/ChangeStep'
import { SaveStatus } from '@/calendesk/models/SaveStatus'
import DraftStateController from '@/calendesk/controllers/DraftStateController'

interface HistoryEntry {
  index: number;
  label: string;
  time: string;
  current: boolean;
  undone: boolean;
}

const formatTime = (epochMs: number): string => {
  const date = new Date(epochMs)

  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

export default Vue.extend({
  name: 'Sidebar',
  computed: {
    ...mapGetters({
      sidebar: 'sidebar/getSidebar',
      changeSteps: 'builder/getChangeSteps',
      currentStepIndex: 'builder/getCurrentStepIndex',
      sidebarDetails: 'sidebar/getSidebarDetails',
      saveStatus: 'builder/getSaveStatus',
      lastSavedAt: 'builder/getLastSavedAt'
    }),
    drawer: {
      get () {
        return this.sidebar
      },
      set (value: Sidebar) {
        store.dispatch('sidebar/openSidebar', value)
      }
    },
    getSidebarTab () {
      const sidebarTab = sidebarTabs.find(_ => _.type === this.sidebar.type)
      if (!sidebarTab) return null
      return sidebarTab.component
    },
    lastSavedTime (): string | null {
      return this.lastSavedAt ? formatTime(this.lastSavedAt) : null
    },
    saveStatusLabel (): string {
      if (this.saveStatus === SaveStatus.SAVING) {
        return this.$trans('wb_save_status_saving')
      }

      if (this.saveStatus === SaveStatus.ERROR) {
        return this.$trans('wb_save_status_error')
      }

      if (this.lastSavedTime) {
        return this.$trans('wb_save_status_saved_at', { time: this.lastSavedTime })
      }

      // Nothing has been saved in this session yet - the full explanation
      // lives in the tooltip, the label stays short enough for one line.
      return this.$trans('wb_auto_save_short')
    },
    saveStatusTooltip (): string {
      return this.lastSavedTime
        ? this.$trans('wb_save_status_saved_at', { time: this.lastSavedTime })
        : this.$trans('wb_auto_save_info')
    },
    // Newest first; entries above the cursor are undone and render dimmed.
    historyEntries (): Array<HistoryEntry> {
      return this.changeSteps
        .map((step: ChangeStep, index: number) => ({
          index,
          label: step.label || this.$trans('wb_step_generic'),
          time: formatTime(step.createdAt),
          current: index === this.currentStepIndex - 1,
          undone: index >= this.currentStepIndex
        }))
        .reverse()
    }
  },
  methods: {
    ...mapActions({
      closeSidebarDetails: 'sidebar/closeSidebarDetails',
      closeSidebar: 'sidebar/closeSidebar',
      restoreLastStep: 'builder/restoreLastStep',
      restoreNextStep: 'builder/restoreNextStep'
    }),
    jumpToHistoryEntry (index: number): void {
      store.dispatch('builder/jumpToStep', index).catch(() => undefined)
    },
    retryFailedSaves (): void {
      DraftStateController.getInstance().flushPendingSaves().catch(() => undefined)
    }
  }
})
